import du from '../utils/dom-utilities';

/**
 * Anonymous - Add listenner on scroll on domElement
 *
 * @param  {HTMLElement} [domElement=null] - Desired DOM element
 * @param  {Number} [offsetHeight=0]  - Desired offsetHeight
 * @param  {String} [activeClass='']  - Classname to add when offsetHeight is achieve
 * @param  {Number} [limit=false] - Define window width limit
 * @return {Set|Listenner} - Set sticky state on init and on scroll
 */
export default function(domElement = null, offsetHeight = 0, activeClass = '', limit = 0,
    bodyClass = null) {
    let body = document.body;

    window.addEventListener('optimized-scroll', () => {
        if (window.innerWidth > limit) {
            if (window.pageYOffset >= offsetHeight-50) {
                // Add 50px to make fixed transition smoother on chromium
                du.setClass(domElement, activeClass);
                if (bodyClass) {
                    if (!body.classList.contains(bodyClass)) {
                        du.setClass(body, bodyClass);
                    }
                }

                if (!domElement.classList.contains(activeClass)) {
                    du.setClass(domElement, activeClass);
                }
            } else {
                du.unsetClass(domElement, activeClass);
                if (bodyClass) {
                    if (domElement.classList.contains(activeClass)) {
                        du.setClass(domElement, activeClass);
                    }

                    if (body.classList.contains(bodyClass)) {
                        du.unsetClass(body, bodyClass);
                    }
                }
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/main/js/components/sticky.js